var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.8026 13.7335L43.4693 6.8668C41.5693 6.1668 38.4693 6.1668 36.5693 6.8668L18.2359 13.7335C14.7026 15.0668 11.8359 19.2001 11.8359 22.9668V49.9668C11.8359 52.6668 13.6026 56.2335 15.7693 57.8335L34.1026 71.5335C37.3359 73.9668 42.6359 73.9668 45.8693 71.5335L64.2026 57.8335C66.3693 56.2001 68.1359 52.6668 68.1359 49.9668V22.9668C68.1693 19.2001 65.3026 15.0668 61.8026 13.7335ZM51.6026 32.4001L37.2693 46.7335C36.7693 47.2335 36.1359 47.4668 35.5026 47.4668C34.8693 47.4668 34.2359 47.2335 33.7359 46.7335L28.4026 41.3335C27.4359 40.3668 27.4359 38.7668 28.4026 37.8001C29.3693 36.8335 30.9693 36.8335 31.9359 37.8001L35.5359 41.4001L48.1026 28.8335C49.0693 27.8668 50.6693 27.8668 51.6359 28.8335C52.6026 29.8001 52.6026 31.4335 51.6026 32.4001Z",
    fill: "#0082CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.3a337321dd51e59d86464adff0dc6b12.svg";
export { ForwardRef as ReactComponent };